// extracted by mini-css-extract-plugin
export var bodySections = "_bt-8";
export var gray = "_bt-7";
export var green = "_bt-4";
export var iconContainer = "_bt-9";
export var iconWidgetContainer = "_bt-1";
export var phoneIcon = "_bt-2";
export var red = "_bt-5";
export var statusDot = "_bt-3";
export var widgetContainer = "_bt-0";
export var yellow = "_bt-6";